import { IPrescription } from "@curefit/care-common";
import LocalStorageUtils from "./LocalStorageUtils";
import {AUTO_SAVE_MEDIUMS, PREFERRED_AUTO_SAVE_MEDIUM} from "../../../common/configs/configs";
import SocketIOUtils from "./SocketIOUtils";
import {ApiManager} from "../api/ApiManager";

declare var socket: any;

export default class AutoSaveUtils {
    static savePrescription(consultationId: number, prescription: IPrescription) {
        LocalStorageUtils.savePrescription(consultationId, prescription);

        if (PREFERRED_AUTO_SAVE_MEDIUM === AUTO_SAVE_MEDIUMS.SOCKET as any) {
            if (typeof socket !== "undefined") {
                SocketIOUtils.savePrescription(consultationId, prescription)
            } else {
                console.log("Socket object not found. Falling back to http for prescription auto-save.")

                let autoSaveRequest = { id: consultationId, prescription: prescription };
                ApiManager.getOrionApis().savePrescriptionInRedis(autoSaveRequest)
            }
        } else if (PREFERRED_AUTO_SAVE_MEDIUM === AUTO_SAVE_MEDIUMS.HTTP) {
            let autoSaveRequest = { id: consultationId, prescription: prescription };
            ApiManager.getOrionApis().savePrescriptionInRedis(autoSaveRequest)
        }
    }

    static deletePrescription(consultationId: number) {
        LocalStorageUtils.clearPrescription(consultationId);

        if (PREFERRED_AUTO_SAVE_MEDIUM === AUTO_SAVE_MEDIUMS.SOCKET as any) {
            if (typeof socket !== "undefined") socket.emit("deletePrescription", consultationId);
            else {
                console.log("Socket object not found. Falling back to http for clearing auto-saved prescription")

                ApiManager.getOrionApis().removePrescriptionFromRedis(consultationId);
            }
        } else if (PREFERRED_AUTO_SAVE_MEDIUM === AUTO_SAVE_MEDIUMS.HTTP) {
            ApiManager.getOrionApis().removePrescriptionFromRedis(consultationId);
        }
    }
}